import { Box } from '@mui/material';
import { DealForm } from 'components/featured/Deals/components/DealForm';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchDealById } from 'store/slices/dealsSlice';

const DealEdit = () => {
  const { id } = useParams();

  const dispatch = useAppDispatch();
  const { loading, deal } = useAppSelector((state) => state.deals);

  useEffect(() => {
    if (!id) return;

    const fetchDeal = async () => {
      try {
        await dispatch(fetchDealById(id));
      } catch (error) {
        console.error(error);
      }
    };

    fetchDeal();
  }, [dispatch, id]);

  if (loading === 'in-progress') return <>Loading...</>;

  return (
    <Box sx={{ height: 'calc(100vh - 160px)' }}>
      <DealForm deal={deal} isEdit={true} />
    </Box>
  );
};

export default DealEdit;
